import { Accessor, Setter, createContext, createMemo, createSignal, useContext } from "solid-js";

export class TableContext {
    columnIds: Accessor<string[]>; private setColumnIds: Setter<string[]>;
    maxHeaderDepth: Accessor<number>; private setMaxHeaderDepth: Setter<number>;
    hiddenColumnIds: Accessor<string[]>; private setHiddenColumnIds: Setter<string[]>;
    page: Accessor<number>; setPage: Setter<number>;
    loading: Accessor<boolean>; setLoading: Setter<boolean>;

    visibleColumnIds: Accessor<string[]>

    constructor() {
        [this.columnIds, this.setColumnIds] = createSignal<string[]>([]);
        [this.maxHeaderDepth, this.setMaxHeaderDepth] = createSignal<number>(0);
        [this.hiddenColumnIds, this.setHiddenColumnIds] = createSignal<string[]>([]);
        [this.page, this.setPage] = createSignal<number>(0);
        [this.loading, this.setLoading] = createSignal<boolean>(false);

        this.visibleColumnIds = createMemo(() => {
            return this.columnIds().filter((id) => !this.hiddenColumnIds().includes(id))
        })
    }

    registerColumn(id: string, depth: number) {
        this.setColumnIds((ids) => [...ids, id])
        this.setMaxHeaderDepth((max) => Math.max(max, depth))
    }

    toggleColumnVisibility(id: string, visible?: boolean) {
        const isVisible = !this.hiddenColumnIds().includes(id);
        const targetState = visible ?? !isVisible;

        this.setHiddenColumnIds((ids) => {
            if (targetState) {
                return ids.filter((i) => i !== id)
            } else {
                return [...ids, id]
            }
        })
    }
}


const _Context = createContext<TableContext>()
export const TableProvider = _Context.Provider;

export const useTable = () => {
    const ctx = useContext(_Context)
    if (!ctx) throw new Error('useTable must be called from a child of STTable')
    return ctx;
}